<script>
    import data from './data/all_with_trends.json';
    import { extent, max } from 'd3-array';
    import { scaleLinear } from 'd3-scale';
    import FreezingDaysChart from './components/FreezingDaysChart.svelte';

    import iceDrawing from './img/ice_Drawing.jpg';
    export let width;
    
    const height = 250;

    let x = width / 2;

    // Filter out Innsbruck 1976
    const filteredData = data.filter(d => !(d.city === 'Innsbruck' && d.games_year === 1976));

    // Get unique cities with their first venue and games_year, then sort by games_year
    const cityMap = new Map();
    filteredData.forEach(item => {
        if (!cityMap.has(item.city)) {
            cityMap.set(item.city, { venue: item.venue, games_year: item.games_year });
        }
    });
    const venues = Array.from(cityMap.values())
        .sort((a, b) => a.games_year - b.games_year)
        .filter(item => item.games_year > 1950) // Sort by games_year
        .map(item => item.venue);
    
    const xExtent = extent(filteredData, d => d.valid_time);
    const yMax = 150;
    const yExtent = [0, yMax];
    let wrapperWidth;
    let columns;

    $: {
        if (wrapperWidth >= 736) {
            columns = 5;
        }  else {
            columns = 3;
        }
        
    }


   
</script>

<div class="multiples-wrapper" bind:clientWidth={wrapperWidth}>
    {#if columns}
    {#each venues as venue, i}
    {@const venueData = filteredData.filter(d => d.venue === venue)}
    {@const showAxisLabels = i % columns === 0}
        <FreezingDaysChart {venue} {xExtent} {yExtent} {showAxisLabels} data={venueData} {columns} {i}/>
    {/each}
    {/if}
</div>

<style>
    .multiples-wrapper {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
    }
    
</style>